export default __webpack_public_path__ + "185d916e30a05f21059b66e37b3ccc1e.wasm";